import { __assign } from "tslib";
import React, { forwardRef } from 'react';
import MuiCollapse from '@material-ui/core/Collapse';
import { useThemeProps } from '../../../foundation';
var _RcCollapse = forwardRef(function (inProps, ref) {
    var props = useThemeProps({ props: inProps, name: 'RcCollapse' });
    return React.createElement(MuiCollapse, __assign({ ref: ref }, props));
});
var RcCollapse = _RcCollapse;
export { RcCollapse };
